import { useSyncExternalStore } from 'react'

// The flag flips at most once, and React re-checks the snapshot when hydration commits.
const subscribeNever = () => () => {}
const getFalse = () => false
const getTrue = () => true

// Per-component, unlike useHydrated, so it stays correct inside a Suspense boundary React hydrates late.
export function useIsHydratingRender(): boolean {
  return useSyncExternalStore(subscribeNever, getFalse, getTrue)
}
